import { BaseButton } from "./base-button";
export class FormButton extends BaseButton {
    get formId() {
        return `${this.buttonId}-form`;
    }
    createDomObject() {
        const object = $("<form>");
        object
            .attr("action", this.url)
            .attr("method", "POST")
            .attr("id", this.formId);
        const button = $("<button>");
        button
            .attr("type", "button")
            .attr("id", this.buttonId)
            .addClass("btn btn-default")
            .attr("title", this.name);
        button.append($("<i>").addClass(this.icon));
        object.append(button);
        $(document).on("click", `#${this.buttonId}`, (event) => this.onAction(event));
        return object.wrap("<div>");
    }
    doAction() {
        $(`#${this.formId}`).submit();
    }
}
